import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import App from "./App";
// const App = React.lazy(() => import(/* webpackChunkName: "App" */'./App' ));
// console.log(window.location.pathname)
ReactDOM.render(
    <Provider store={configureStore()}>
        <Router>
            <Switch>
                <Route path="/" component={App} />
            </Switch>
        </Router>
    </Provider>,
  document.getElementById('root')
);

//<Provider store={configureStore()}>
//         <Suspense fallback={<div className="loading" />}>
//             <Router>
//                 <Switch>
//                     <Route path="/" component={App} />
//                 </Switch>
//             </Router>
//         </Suspense>
//     </Provider>,
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister();
